import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall } from "../../utils/ApiMethods";


const FetchCategoryForumConfigAction = (emailId) => {
    return async function (dispatch) {
        const data = await getApiCall(`${appConstants.BASE_URL}/category-forum/config?emailId=${encodeURIComponent(emailId)}`);
        var resData = Object.assign({ type: 'SUCCESS_CATEGORY_FORUM_CONFIG_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchCategoryForumTableAction = (year) => {
    return async function (dispatch) {
        const yearParam = year || new Date().getFullYear();
        let data = await getApiCall(`${appConstants.BASE_URL}/category-forum/table-data-by-year?year=${yearParam}`);

        var resData = Object.assign({ type: 'SUCCESS_CATEGORY_FORUM_TABLE_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchCategoryForumYearToDateDateAction = () => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_CATEGORY_FORUM_YEAR_TO_DATE_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/category-forum/contracts-board-dashboard-data/year-to-date`);
            var resData = Object.assign({ type: 'SUCCESS_CATEGORY_FORUM_YEAR_TO_DATE_ACTION' }, data);
            dispatch(resData);

        } catch (error) {
            dispatch({ type: 'ERROR_CATEGORY_FORUM_YEAR_TO_DATE_ACTION', error });
        }

        
        dispatch(resData);
    };
};
const FetchCategoryForumForumsByCategoryAction = () => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_CATEGORY_FORUM_FORUMS_BY_CATEGORY_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/category-forum/contracts-board-dashboard-data/forums-by-category`);
            var resData = Object.assign({ type: 'SUCCESS_CATEGORY_FORUM_FORUMS_BY_CATEGORY_ACTION' }, data);
            dispatch(resData);

        } catch (error) {
            dispatch({ type: 'ERROR_CATEGORY_FORUM_FORUMS_BY_CATEGORY_ACTION', error });
        }

        
        dispatch(resData);
    };
};
const FetchCategoryForumBalanceOfTheYearAction = () => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_CATEGORY_FORUM_BALANCE_OF_THE_YEAR_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/category-forum/contracts-board-dashboard-data/balance-of-the-year`);
            var resData = Object.assign({ type: 'SUCCESS_CATEGORY_FORUM_BALANCE_OF_THE_YEAR_ACTION' }, data);
            dispatch(resData);

        } catch (error) {
            dispatch({ type: 'ERROR_CATEGORY_FORUM_BALANCE_OF_THE_YEAR_ACTION', error });
        }

        
        dispatch(resData);
    };
};
const FetchCategoryForumSummaryAction = () => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_CATEGORY_FORUM_SUMMARY_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/category-forum/contracts-board-dashboard-data/summary`);
            var resData = Object.assign({ type: 'SUCCESS_CATEGORY_FORUM_SUMMARY_ACTION' }, data);
            dispatch(resData);

        } catch (error) {
            dispatch({ type: 'ERROR_CATEGORY_FORUM_SUMMARY_ACTION', error });
        }

        
        dispatch(resData);
    };
};
const FetchCategoryForumContractBoardsDetailsAction = (emailId) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_CATEGORY_FORUM_CONTRACT_BOARDS_DETAILS_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/category-forum/contracts-board-dashboard-data/contract-boards-details?emailId=${encodeURIComponent(emailId)}`);
            var resData = Object.assign({ type: 'SUCCESS_CATEGORY_FORUM_CONTRACT_BOARDS_DETAILS_ACTION' }, data);
            dispatch(resData);

        } catch (error) {
            dispatch({ type: 'ERROR_CATEGORY_FORUM_CONTRACT_BOARDS_DETAILS_ACTION', error });
        }

        
        dispatch(resData);
    };
};

const FetchCategoryForumActionTrackerFiltersAction = () => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_CATEGORY_FORUM_ACTION_TRACKER_FILTERS_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/category-forum/action-items-tracker/get-filters`);
            var resData = Object.assign({ type: 'SUCCESS_CATEGORY_FORUM_ACTION_TRACKER_FILTERS_ACTION' }, data);
            dispatch(resData);
            return data;
        } catch (error) {
            dispatch({ type: 'ERROR_CATEGORY_FORUM_ACTION_TRACKER_FILTERS_ACTION', error });
            return null;
        }
    };
};

const FetchCategoryForumActionTrackerHeaderDataAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_CATEGORY_FORUM_ACTION_TRACKER_HEADER_DATA_ACTION', requestedYear: payload.year });
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/category-forum/action-items-tracker/header-data`, payload);
            var resData = Object.assign({ type: 'SUCCESS_CATEGORY_FORUM_ACTION_TRACKER_HEADER_DATA_ACTION', requestedYear: payload.year }, data);
            dispatch(resData);
            return data;
        } catch (error) {
            dispatch({ type: 'ERROR_CATEGORY_FORUM_ACTION_TRACKER_HEADER_DATA_ACTION', error });
            return null;
        }
    };
};

const FetchCategoryForumActionTrackerTabularDataAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_CATEGORY_FORUM_ACTION_TRACKER_TABULAR_DATA_ACTION', requestedYear: payload.year });
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/category-forum/action-items-tracker/tabular-data`, payload);
            var resData = Object.assign({ type: 'SUCCESS_CATEGORY_FORUM_ACTION_TRACKER_TABULAR_DATA_ACTION', requestedYear: payload.year }, data);
            dispatch(resData);
            return data;
        } catch (error) {
            dispatch({ type: 'ERROR_CATEGORY_FORUM_ACTION_TRACKER_TABULAR_DATA_ACTION', error });
            return null;
        }
    };
};

const FetchCategoryForumActionTrackerChartDataAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_CATEGORY_FORUM_ACTION_TRACKER_CHART_DATA_ACTION', requestedYear: payload.year });
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/category-forum/action-items-tracker/chart-data`, payload);
            var resData = Object.assign({ type: 'SUCCESS_CATEGORY_FORUM_ACTION_TRACKER_CHART_DATA_ACTION', requestedYear: payload.year }, data);
            dispatch(resData);
            return data;
        } catch (error) {
            dispatch({ type: 'ERROR_CATEGORY_FORUM_ACTION_TRACKER_CHART_DATA_ACTION', error });
            return null;
        }
    };
};

const FetchCategoryForumOutcomeSummaryFiltersAction = () => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_CATEGORY_FORUM_OUTCOME_SUMMARY_FILTERS_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/category-forum/outcomes-tracker/get-filters`);
            var resData = Object.assign({ type: 'SUCCESS_CATEGORY_FORUM_OUTCOME_SUMMARY_FILTERS_ACTION' }, data);
            dispatch(resData);
            return data;
        } catch (error) {
            dispatch({ type: 'ERROR_CATEGORY_FORUM_OUTCOME_SUMMARY_FILTERS_ACTION', error });
            return null;
        }
    };
};


const FetchCategoryForumOutcomeSummaryTabularDataAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_CATEGORY_FORUM_OUTCOME_SUMMARY_TABULAR_DATA_ACTION', requestedYear: payload.year });
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/category-forum/outcomes-tracker/tabular-data`, payload);
            var resData = Object.assign({ type: 'SUCCESS_CATEGORY_FORUM_OUTCOME_SUMMARY_TABULAR_DATA_ACTION', requestedYear: payload.year }, data);
            dispatch(resData);
            return data;
        } catch (error) {
            dispatch({ type: 'ERROR_CATEGORY_FORUM_OUTCOME_SUMMARY_TABULAR_DATA_ACTION', error });
            return null;
        }
    };
};

const FetchYourCategoryForumUserCalendarAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_YOUR_CATEGORY_FORUM_USER_CALENDAR_ACTION', requestedYear: payload.year });
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/category-forum/category-forums-user-calendar`, payload);
            var resData = Object.assign({ type: 'SUCCESS_YOUR_CATEGORY_FORUM_USER_CALENDAR_ACTION', requestedYear: payload.year }, data);
            dispatch(resData);
            return data;
        } catch (error) {
            dispatch({ type: 'ERROR_YOUR_CATEGORY_FORUM_USER_CALENDAR_ACTION', error });
            return null;
        }
    };
};

export {
    FetchCategoryForumConfigAction,
    FetchCategoryForumTableAction,
    FetchCategoryForumForumsByCategoryAction,
    FetchCategoryForumContractBoardsDetailsAction,
    FetchCategoryForumBalanceOfTheYearAction,
    FetchCategoryForumSummaryAction,
    FetchCategoryForumYearToDateDateAction,
    FetchCategoryForumActionTrackerFiltersAction,
    FetchCategoryForumActionTrackerHeaderDataAction,
    FetchCategoryForumActionTrackerTabularDataAction,
    FetchCategoryForumActionTrackerChartDataAction,
    FetchCategoryForumOutcomeSummaryFiltersAction,
    FetchCategoryForumOutcomeSummaryTabularDataAction,
    FetchYourCategoryForumUserCalendarAction
}